import {CP, initParam} from "../setting/initParam"
import {
    CalcBoardParamFromDiagonal,
    calcColumnLineFromSegment,
    CalcPlaceFromDiagonal,
    centeredLine, createDefaultMaterial,
    createSegmentsFromLine,
    CutPlane,
    DiagonalVariantCalc,
    DirectionVec,
    getMetaNumber,
    InitialStruct,
    JoinPlane,
    JoinType,
    JoinVariant,
    matBeam,
    ParamsGetSimpleBoard,
    PositionVec,
    RenderElement,
    RenderStruct,
    simpleSize,
    updateLimitedPointsOnLine,
    Vec2,
    Vec3
} from "@3dcalc/3dpClient";
import {api} from "../api/api";
import {InitialStructWhithBlock} from "@3dcalc/3dpClient/dist/types/types";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";

export async function getRafter(s:InitialStructWhithBlock, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {

    const paramBoardL = CalcBoardParamFromDiagonal(
        s.a,
        s.w / 2,
        s.e.left,
        0,
        initParam.elementData.rafter.sizeBoard.h,
        DiagonalVariantCalc.Bottom,
    )
    const paramBoardR = CalcBoardParamFromDiagonal(
        s.a,
        s.w / 2,
        s.e.right,
        0,
        initParam.elementData.rafter.sizeBoard.h,
        DiagonalVariantCalc.Bottom,
    )

    const placeL = CalcPlaceFromDiagonal(s.a, s.w / 2, s.e.left)
    const placeR = CalcPlaceFromDiagonal(s.a, s.w / 2, s.e.right)

    CP.maps.f2.param = {h: placeL.h, l: placeL.l, p: placeL.p, w: placeL.w}
    CP.maps.rafter.shiftBottom.left = placeL.shift.front.h
    CP.maps.rafter.shiftBottom.right = placeR.shift.front.h

    const paramsGetSimpleBoardLeft: ParamsGetSimpleBoard = {
        modeBuild: modeBuild,
        // shift: {back: paramBoardL.dSFront - initParam.elementData.ridge.sizeBoard.w / 2, front: 0},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l: paramBoardL.dBoard +  + paramBoardL.dSFront},
        cuts: [],
        joinEnd: {
            joinType: JoinType.End,
            joinPlane: JoinPlane.Bottom,
            indent: 0,
            angle:  90 - s.a,
            variant: JoinVariant.Angle
        },
        joinStart: {
            joinType: JoinType.Start,
            joinPlane: JoinPlane.Top,
            indent: 0,
            angle:  90 - s.a,
            variant: JoinVariant.Angle,
        },
        angleCuts: [
            {
                gash: initParam.elementData.ridge.sizeBoard.w / 2,
                a: 90-s.a,
                z: -1,
                plane: CutPlane.Top,
                direction: DirectionVec.Up,
                position: PositionVec.Down
            },
            {
                gash: initParam.elementData.ridge.sizeBoard.w / 2,
                a: 90-s.a,
                z: paramBoardL.dBoard,
                plane: CutPlane.Top,
                direction: DirectionVec.Up,
                position: PositionVec.Up
            },
        ]
    }
    const paramsGetSimpleBoardRight: ParamsGetSimpleBoard = {
        modeBuild: modeBuild,
        // shift: {back: paramBoardR.dSFront - initParam.elementData.ridge.sizeBoard.w / 2, front: 0},
        // sizeBoard: {w: sBoard.w, h: sBoard.h, l: paramBoardR.dBoard + initParam.elementData.ridge.sizeBoard.w / 2},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l: paramBoardR.dBoard + paramBoardR.dSFront},
        cuts: [],
        joinEnd: {
            joinType: JoinType.End,
            joinPlane: JoinPlane.Bottom,
            indent: 0,
            angle:  90 - s.a,
            variant: JoinVariant.Angle
        },
        joinStart: {
            joinType: JoinType.Start,
            joinPlane: JoinPlane.Top,
            indent: 0,
            angle:  90 - s.a,
            variant: JoinVariant.Angle,
        },
        angleCuts: [
            {
                gash: initParam.elementData.ridge.sizeBoard.w / 2,
                a: 90-s.a,
                z: -1,
                plane: CutPlane.Top,
                direction: DirectionVec.Up,
                position: PositionVec.Down
            },
            {
                gash: initParam.elementData.ridge.sizeBoard.w / 2,
                a: 90-s.a,
                z: paramBoardL.dBoard,
                plane: CutPlane.Top,
                direction: DirectionVec.Up,
                position: PositionVec.Up
            },
        ]
    }
    const rs:RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []
    const specIds: string[] = []
    rs.material.push(createDefaultMaterial())

    const linePlace:Vec2[] = [...CP.maps.rafter.lineCut]
    linePlace[linePlace.length - 1][0] += initParam.elementData.rafter.sizeBoard.w
    linePlace[linePlace.length - 2][0] -= initParam.elementData.rafter.sizeBoard.w / 2
    linePlace.push([s.l + s.block.w + s.e.back - initParam.elementData.rafter.sizeBoard.w / 2, 0])
    linePlace.unshift([0 - s.e.front + initParam.elementData.rafter.sizeBoard.w / 2, 0])
    const linePlaceFull = updateLimitedPointsOnLine(linePlace, initParam.elementData.rafter.sizeBoard.w)
    const centeredLinePlace = centeredLine(linePlace, s.l + s.block.w)

    const resultGetSimpleBoardLeft = await api.getSimpleBoard.build(paramsGetSimpleBoardLeft)
    const resultGetSimpleBoardRight = await api.getSimpleBoard.build(paramsGetSimpleBoardRight)

    rs.uvs.push(resultGetSimpleBoardLeft.mesh.uvs)
    const numUvsL = rs.uvs.length - 1
    rs.uvs.push(resultGetSimpleBoardRight.mesh.uvs)
    const numUvsR = rs.uvs.length - 1
    rs.indices.push(resultGetSimpleBoardLeft.mesh.indices)
    const numIndicesL = rs.indices.length - 1
    rs.indices.push(resultGetSimpleBoardRight.mesh.indices)
    const numIndicesR = rs.indices.length - 1
    rs.vertices.push(resultGetSimpleBoardLeft.mesh.vertices)
    const numVerticesL = rs.vertices.length - 1
    rs.vertices.push(resultGetSimpleBoardRight.mesh.vertices)
    const numVerticesR = rs.vertices.length - 1
    const nameGroup = 'rafter'
    const specID = nameGroup
    rs.group = nameGroup
    const numGroups = rs.group.length
    const metaL = resultGetSimpleBoardLeft.meta
    const metaR = resultGetSimpleBoardRight.meta

    CP.maps.rafter.hCut = metaL.cuts[0].l2
    CP.maps.rafter.l.left = paramBoardL.dFull - getMetaNumber(metaL.modify, "joinEnd", "offset")
    CP.maps.rafter.l.right = paramBoardR.dFull - getMetaNumber(metaR.modify, "joinEnd", "offset")

    CP.maps.rafter.hGash = getMetaNumber(metaL.modify, "joinStart", "width")

    const segments = createSegmentsFromLine(centeredLinePlace)

    const mapRafters:Vec2[] = []

    for (let i = 0; i < segments.length; i++) {
        mapRafters.push(segments[i].from)
        const _line = calcColumnLineFromSegment(segments[i], initParam.setting.rafterMaxSpan)
        mapRafters.push(..._line)
    }
    mapRafters.push(segments[segments.length - 1].to)

    CP.maps.rafter.mapCentered = updateLimitedPointsOnLine(mapRafters, initParam.elementData.rafter.sizeBoard.w)

    initParam.gash.rafterAngle = metaL.cuts[0].l2

    for (let i = mapRafters.length - 1; i >= 0; i--) {

        const X = mapRafters[i][0]// + s.block.w / 2

        const Yl =
            + placeL.w / 2
            + s.e.left / 2

        const Yr =
            - placeR.w / 2
            - s.e.right / 2

        const Zl = s.h
            + initParam.elementData.harness.sizeBoard.h
            - initParam.gash.simple
            + placeL.h / 2
            - placeL.shift.front.h / 2
            + paramBoardL.h / 2
            - metaL.cuts[0].l2

        const Zr = s.h
            + initParam.elementData.harness.sizeBoard.h
            - initParam.gash.simple
            + placeR.h / 2
            - placeR.shift.front.h / 2
            + paramBoardR.h / 2
            - metaL.cuts[0].l2

        const posL: Vec3 = [X, Zl, Yl]
        const posR: Vec3 = [X, Zr, Yr]
        const rotL: Vec3 = [Math.PI / 2 + s.r, 0, 0,]
        const rotR: Vec3 = [Math.PI - s.r + Math.PI / 2, Math.PI, 0,]

        const boardL: RenderElement = {
            indices: numIndicesL,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posL,
            rotation: rotL,
            uvs: numUvsL,
            vertices: numVerticesL,
            material: 0,
            specId: specID+'L'
        }
        rs.elements.push(boardL)
        const boardR: RenderElement = {
            indices: numIndicesR,
            name: `${nameGroup} - ${i}`,
            nameGroup: specID+'R',
            position: posR,
            rotation: rotR,
            uvs: numUvsR,
            vertices: numVerticesR,
            material: 0,
            specId: specID+'R'
        }
        rs.elements.push(boardR)
    }
    spec.push({
        w: resultGetSimpleBoardLeft.meta.w,
        h: resultGetSimpleBoardLeft.meta.h,
        l: resultGetSimpleBoardLeft.meta.l,
        name: "Левые стропила",
        group: nameGroup,
        count: mapRafters.length,
        specId: specID+'L'
    },{
        w: resultGetSimpleBoardRight.meta.w,
        h: resultGetSimpleBoardRight.meta.h,
        l: resultGetSimpleBoardRight.meta.l,
        name: "Правые стропила",
        group: nameGroup,
        count: mapRafters.length,
        specId: specID+'R'
    },)
    specIds.push(specID + 'L', specID + 'R')
    rs.specIds = specIds


    return {rs:rs, spec: spec}
}
